













import tabCard from "./card.vue";
import tabLog from "./log.vue";
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "integralLog",
  components: {
    tabCard,
    tabLog,
  },
})
export default class extends Vue {
  activeName: string = "card";
}
